// extracted by mini-css-extract-plugin
export var numpadContainer = "_hr-1";
export var phoneButton = "_hr-0";